import React from 'react';
import classnames from 'classnames';
import {Subject} from 'rxjs/Subject';
import {number, bool, func} from 'prop-types';
import {Input, Grid} from 'semantic-ui-react';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {validationRules} from 'components/forms/validationRules';

const DEBOUNCE_TIME = 1000;

const validationParams = {
  min: 0,
  max: 100 * 1000
};

export default class AutoSaveQuantityInput extends React.Component {
  static propTypes = {
    value: number.isRequired,
    onChange: func.isRequired,
    apiError: bool,
    didSave: bool
  };

  static defaultProps = {
    apiError: false,
    didSave: false
  };

  changeEmitter = new Subject().auditTime(DEBOUNCE_TIME);

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.changeEmitter.subscribe(this.props.onChange);
  }

  get initialState() {
    return {
      isSaving: false,
      value: this.props.value,
      validationError: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.apiError !== this.props.apiError || nextProps.didSave !== this.props.didSave) {
      this.setState({isSaving: false});
    }
  }

  handleChange = (event, {value}) => {
    value = Number(value);

    const validationError = ['NumberFormat', 'InclusiveRange'].find(rule => {
      const isValid = validationRules[rule](value, validationParams);
      return !isValid;
    });

    this.setState({
      isSaving: !validationError,
      value,
      validationError: validationError || this.initialState.validationError
    });

    if (!validationError) {
      this.changeEmitter.next(value);
    }
  };

  render() {
    const error = !this.state.isSaving && (this.state.validationError || this.props.apiError);
    return (
      <div className={classnames('auto-save-quantity-input', {error})}>
        <Grid>
          <Grid.Column width={11}>
            <Input
              type='number'
              error={error}
              value={this.state.value}
              onChange={this.handleChange} />
          </Grid.Column>
          <Grid.Column width={1}>
            <div className='vertical-spacer'>&nbsp;</div>
            <FieldStatusIcon
              error={error}
              isSaving={this.state.isSaving}
              saved={!this.state.isSaving && this.props.didSave} />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/AutoSaveQuantityInput.jsx